import {
  Button,
  Divider,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Switch,
  SwitchOnChangeData,
  Text,
} from "@fluentui/react-components";
import { SettingsRegular } from "@fluentui/react-icons";
import { useAtom } from "jotai";
import { SelectItem } from "library/types";
import { useTranslation } from "react-i18next";
import { benefitCardImageAtom, darkModeAtom } from "store";
import styled from "styled-components";

import { Flex } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";

import { SelectLanguage } from "../SelectLanguage";
import { ThemeSettings } from "../ThemeSettings";

type Props = {
  languageOptions: SelectItem[];
  onSelect: (event: React.FormEvent<HTMLDivElement>, option?: SelectItem, index?: number) => void;
  selectedLanguage: string;
};

export function SettingsMenu({ languageOptions, onSelect, selectedLanguage }: Props) {
  const theme = useAppTheme();
  const { t } = useTranslation();
  const [showImages, setShowImages] = useAtom(benefitCardImageAtom);
  const [isDarkMode, setIsDarkMode] = useAtom(darkModeAtom);

  return (
    <Container>
      <Menu positioning={{ autoSize: true }} persistOnItemClick>
        <MenuTrigger disableButtonEnhancement>
          <Button
            size="large"
            appearance="transparent"
            icon={<SettingsRegular fontSize={25} />}
            style={{
              color: theme.palette.purpleDark,
              minWidth: "fit-content",
            }}
          />
        </MenuTrigger>

        <MenuPopover
          style={{
            padding: 0,
          }}
        >
          <MenuList
            style={{
              padding: "10px 0",
              width: "250px",
            }}
          >
            <StyledMenuItem>
              <SelectLanguage
                languageOptions={languageOptions}
                onSelect={onSelect}
                selectedLanguage={selectedLanguage}
              />
            </StyledMenuItem>
            <Divider
              style={{
                padding: "5px 0",
              }}
            />
            <StyledMenuItem>
              <ThemeSettings />
            </StyledMenuItem>
            <Divider
              style={{
                padding: "5px 0",
              }}
            />

            <StyledMenuItem>
              <Flex width={"100%"} $justify="space-between">
                <Text>{t("hbh.cardImage.label")}</Text>
                <Switch
                  defaultChecked={showImages}
                  onChange={(_, data: SwitchOnChangeData) => {
                    setShowImages(!!data.checked);
                  }}
                  indicator={{
                    style: {
                      margin: 0,
                    },
                  }}
                />
              </Flex>
            </StyledMenuItem>
            <StyledMenuItem>
              <Flex width={"100%"} $justify="space-between">
                <Text>{t("header.DarkMode")}</Text>
                <Switch
                  defaultChecked={isDarkMode}
                  onChange={(_, data: SwitchOnChangeData) => {
                    setIsDarkMode(!!data.checked);
                  }}
                  indicator={{
                    style: {
                      margin: 0,
                    },
                  }}
                />
              </Flex>
            </StyledMenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    </Container>
  );
}

const Container = styled.div``;
const StyledMenuItem = styled(MenuItem)`
  padding: 7px 20px !important;
`;
